export type GoogleLoginActionProps = {
  onVerify?: (token: string, onboarded: boolean) => void | Promise<void>;
  disabled?: boolean;
  tryStart?: () => boolean;
  onFinish?: () => void;
};

// Web GIS authentication is not wired yet. Never load Nitro in a browser.
export default function GoogleLoginAction(_props: GoogleLoginActionProps) { return null; }
